export class ProbationFeedbackSummaryDTO {
    public actionItems :string
    public developments: String;
    public strengths :string
    constructor() {
        this.actionItems="";
        this.developments="";
        this.strengths="";
     }
}